import { render, staticRenderFns } from "./AddLook.vue?vue&type=template&id=7ed7547c&"
import script from "./AddLook.vue?vue&type=script&lang=ts&"
export * from "./AddLook.vue?vue&type=script&lang=ts&"
import style0 from "./AddLook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports